import {Component, OnInit, ViewChild} from '@angular/core';
import { GenericDataViewService } from '../generic-data-view.service';
import { App, IonicPage, NavController, NavParams } from 'ionic-angular';
import { ListConfig } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { FiltersConfig } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filters-config.interface';
import { FiltersService } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/filters/filters.service';
import { ProcessService } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service';
import { ListRendererComponent } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/list/list.component';
import { ProcessFormService } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process-form.service';
import {Utils} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/utils/utils.class";
import { FormField } from '../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-field.interface';
import {
  FormDefinition
} from "../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-definition.interface";


@IonicPage()
@Component({
  selector: 'generic-data-view-list',
  templateUrl: './generic-data-view-list.page.html',
})
export class GenericDataViewListPage implements OnInit {
  @ViewChild('list') list: ListRendererComponent;
  public config: ListConfig;
  public filtersConfig: FiltersConfig;
  public baseUrl: string;
  public title: string = '';
  public db: any;
  public dataReceived: boolean = false;
  private viewId: string;
  public loading: boolean = true;
  public showSearchBar: boolean = false;

  constructor(
              private app: App,
              private genericDataViewService: GenericDataViewService,
              private navParams: NavParams,
              private navController: NavController,
              private filtersService: FiltersService,
              private processService: ProcessService,
              private processFormService: ProcessFormService,) {}

  ngOnInit() {
    this.setTitle();
    this.setConfig();
  }

  private setTitle(): void {
    const pageTitle = this.getTitle();
    if (!pageTitle) {
      console.warn('[GenericDataViewListPage] A page title is missing');
    } else {
      this.title = pageTitle;
    }
  }

  private getTitle(): string {
    const layout = this.navParams.data;
    if (layout && layout.title) {
      return layout.title;
    }

    const tabTitle = this.navController['title'];
    return tabTitle ? tabTitle : null;
  }

  private setConfig(): void {
    this.viewId = this.getViewId();
    this.config = this.genericDataViewService.getConfig(this.viewId);
    this.filtersConfig = this.config.filtersViewId ? this.genericDataViewService.getConfig(this.config.filtersViewId) : null;
    this.baseUrl = this.genericDataViewService.getBaseUrl(this.config);
    this.showSearchBar = this.config.displayConfig.showSearchBar;
  }

  private getViewId(): string {
    const layout = this.navParams.data;
    if (layout && layout.viewId) {
      return layout.viewId;
    }

    const tabViewId = this.navController['tabId'];
    return tabViewId ? tabViewId : null;
  }

  goTo($event: { viewId: string; element?: Object; objectKey?: Object; viewComponent: string }) {
    this.app.getRootNav().push($event.viewComponent, { viewId: $event.viewId, element: $event.element });
  }

  extractOptionsFromData(data: any[]) {
    if (!this.dataReceived && data.length > 0) {
      this.filtersService.extractOptionsFromData(this.config.name, data);
      this.dataReceived = true;
    }
  }

  onButtonClick($event: { process?: any; element?: Object }): void {
    this.appendFieldsFromMappingParentObjectIntoElement($event);
    this.handleProcessAction($event.process.processKey, $event.element, $event.process.sendButtonText);
  }

  private handleProcessAction(processKey: string, data: Object, sendButtonText: string): void {
    this.processService
      .getProcessWithForm(this.baseUrl, processKey)
      .subscribe((formDefinition: FormDefinition) => {
        const fields = formDefinition.form
        const formName = formDefinition.formName
        this.processService
          .initProcess(this.baseUrl, { formJson: this.getFormJson(fields, data), key: processKey, formName, sendButtonText })
          .subscribe(() => {
            this.loading = true;
            setTimeout(() => {
              this.list.reload();
              this.loading = false;
            }, 3000);
          });
      });
  }

  private getFormJson(formJson: FormField[], data: any): any {
    if (!data) {
      return formJson;
    }
    return this.processFormService.mapFormData(this.config, formJson, data);
  }

  private appendFieldsFromMappingParentObjectIntoElement($event: { process?: any; element?: Object; }) {
    if (this.config.formMappingFromParentObject && this.list.getParams()) {
      if (!$event.element) {
        $event.element = {};
      }
      for (let key in this.config.formMappingFromParentObject) {
        let valueExpression = this.config.formMappingFromParentObject[key];
        let value = Utils.evaluateVariablesString(valueExpression, this.list.getParams());

        $event.element[key] = value
      }
    }
  }

  searchQueryChange(query) {
    if (query.length > 0 && query.length < 3)  return;
    this.filtersService.filterSetSubject$.next({filterConfig: undefined, filters: [], name: "", options: undefined, searchQuery: query});
  }

  setLoading(value): void {
    this.loading = value;
  }
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-list/generic-data-view-list.page.ts